module.exports = __webpack_public_path__ + "img/security-battery.72140ad.svg";